import { Checkbox } from "antd";
import { useMemo } from "react";
import {
  Chargebee_PLAN_NAME_MONTHLY,
  Chargebee_PLAN_NAME_MONTHLY_OLD,
  Chargebee_PLAN_NAME_YEARLY,
  Chargebee_PLAN_NAME_YEARLY_OLD,
  Old_Messaging_Chargebee_PLAN_NAME_MONTHLY,
  Old_Messaging_Chargebee_PLAN_NAME_YEARLY,
  VOICE_CHARGEBEE_PLAN_MONTHLY,
  VOICE_CHARGEBEE_PLAN_YEARLY,
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY,
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY,
} from "../../constants/AppConstants";

export const FEATURE_ENABLED = 1;
export const FEATURE_DISABLED = 0;

export const ringingTypeOptions = [
  { value: 1, label: "Simultaneous" },
  { value: 2, label: "Sequential" },
];

export const ConnectingDot = ({className}) => <div className={`call-action-icons dot-icon ${className}`} />;

export const allowedExtensions = ["mp3", "wav", "aiff", "aif", "gsm", "ulaw"];

export const nodeClassification = {
  IVR_RING_TEAM: "IVR_RING_TEAM",
  WELCOME: "WELCOME",
  RECORD: "RECORD",
  UNAVAILABLE_OUT_OF_BUSINESS_HOURS: "UNAVAILABLE_OUT_OF_BUSINESS_HOURS",
  CALL_ROUTE: "CALL_ROUTE",
  HOLD: "HOLD",
  OPEN: "OPEN",
  CLOSE: "CLOSE",
  BH: "BH",
  NO_ANSWER: "NO_ANSWER",
  BUSY: "BUSY",
  UNAVAILABLE: "UNAVAILABLE",
  HANG_UP: "HANG_UP",
  TEAMS: "TEAMS",
};

export const transcriptionStatus = {
  TRANSCRIBED: 1,
  SUMMARIZED: 2,
  UTTERANCES_GENERATED: 3,
};

export const ringingType = {
  SIMULTANEOUS: 1,
  SEQUENTIAL: 2,
};

export const voiceAgentStatus = {
  ONLINE_WEB: 1,
  ONLINE_PHONE: 2,
  ON_CALL: 3,
  AFTER_CALL_PROCESS: 4,
  BUSY: 5,
  OFFLINE: 6,
};

export const callRouteType = {
  DIRECT: 1,
  IVR: 2,
};

export const voiceAgentMode = {
  OVER_THE_WEB: 1,
  OVER_THE_PHONE: 2,
};

export const AUTOMATED_MESSAGE_TYPE = {
  URL: 1,
  FILE: 2,
  TEXT: 3,
};

export const OVER_THE_PHONE_INBOUND_CALLER_ID_DISPLAY_MODE = {
  CUSTOMER_NUMBER: 1,
  CONFIGURED_TWILIO_NUMBER: 2,
  CHOOSE_CALLER_ID: 3,
};

export const voicePermissionOptions = [
  { label: "All", value: 1 },
  { label: "Inbound", value: 2 },
  { label: "Outbound", value: 3 },
];
const getPlanType = (planName) => {
  if (
    [
      Chargebee_PLAN_NAME_MONTHLY,
      Chargebee_PLAN_NAME_YEARLY,
      Chargebee_PLAN_NAME_MONTHLY_OLD,
      Chargebee_PLAN_NAME_YEARLY_OLD,
      Old_Messaging_Chargebee_PLAN_NAME_MONTHLY,
      Old_Messaging_Chargebee_PLAN_NAME_YEARLY,
    ].includes(planName)
  ) {
    return "Message";
  }
  if ([VOICE_CHARGEBEE_PLAN_MONTHLY, VOICE_CHARGEBEE_PLAN_YEARLY].includes(planName)) {
    return "Call";
  }
  if ([VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY, VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY].includes(planName)) {
    return "Message and Call";
  }
  return "";
};

// export const getPlanSwitchType = (currentPlanName, switchingToPlanName) => {
//   if ([Chargebee_PLAN_NAME_MONTHLY, Chargebee_PLAN_NAME_YEARLY].includes(currentPlanName)) {
//     if ([Chargebee_PLAN_NAME_MONTHLY, Chargebee_PLAN_NAME_YEARLY].includes(switchingToPlanName)) {
//       return 1; //info
//     } else if ([VOICE_CHARGEBEE_PLAN_MONTHLY, VOICE_CHARGEBEE_PLAN_YEARLY].includes(switchingToPlanName)) {
//       return 2; //downgrade
//     } else if ([VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY, VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY].includes(switchingToPlanName)) {
//       return 3; //upgrade
//     }
//   } else if ([VOICE_CHARGEBEE_PLAN_MONTHLY, VOICE_CHARGEBEE_PLAN_YEARLY].includes(currentPlanName)) {
//     if ([Chargebee_PLAN_NAME_MONTHLY, Chargebee_PLAN_NAME_YEARLY].includes(switchingToPlanName)) {
//       return 2;
//     } else if ([VOICE_CHARGEBEE_PLAN_MONTHLY, VOICE_CHARGEBEE_PLAN_YEARLY].includes(switchingToPlanName)) {
//       return 1;
//     } else if ([VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY, VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY].includes(switchingToPlanName)) {
//       return 3;
//     }
//   } else if ([VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY, VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY].includes(currentPlanName)) {
//     if (
//       [Chargebee_PLAN_NAME_MONTHLY, Chargebee_PLAN_NAME_YEARLY, VOICE_CHARGEBEE_PLAN_MONTHLY, VOICE_CHARGEBEE_PLAN_YEARLY].includes(
//         switchingToPlanName
//       )
//     ) {
//       return 2;
//     } else if ([VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY, VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY].includes(switchingToPlanName)) {
//       return 1;
//     }
//   }
//   return 0;
// };

const PLAN_CATEGORIES = {
  MESSAGE: [Chargebee_PLAN_NAME_MONTHLY, Chargebee_PLAN_NAME_YEARLY],
  VOICE: [VOICE_CHARGEBEE_PLAN_MONTHLY, VOICE_CHARGEBEE_PLAN_YEARLY],
  VOICE_PLUS_MESSAGE: [VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY, VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY],
};

const PLAN_SWITCH_MATRIX = {
  MESSAGE: {
    MESSAGE: 1, // Info
    VOICE: 2, // Downgrade
    VOICE_PLUS_MESSAGE: 3, // Upgrade
  },
  VOICE: {
    MESSAGE: 2, // Downgrade
    VOICE: 1, // Info
    VOICE_PLUS_MESSAGE: 3, // Upgrade
  },
  VOICE_PLUS_MESSAGE: {
    MESSAGE: 2, // Downgrade
    VOICE: 2, // Downgrade
    VOICE_PLUS_MESSAGE: 1, // Info
  },
};

export const getPlanSwitchType = (currentPlanName, switchingToPlanName) => {
  const getCurrentPlanCategory = (planName) => {
    return Object.entries(PLAN_CATEGORIES).find(([_, plans]) => plans.includes(planName))?.[0] || "MESSAGE";
  };

  const currentCategory = getCurrentPlanCategory(currentPlanName);
  const switchCategory = getCurrentPlanCategory(switchingToPlanName);

  return PLAN_SWITCH_MATRIX[currentCategory]?.[switchCategory] || 0;
};

export const getCurrentFeature = (appProperties, planToUpdate) => {
  return getPlanType(appProperties?.licenseObj?.licenseDetails?.planName || planToUpdate);
};

export const useVoiceIntegId = (appProperties) => {
  return useMemo(() => {
    const voiceIntegrations = appProperties?.installedApps?.filter((integration) => integration.right.serviceType === "VOICE");
    return voiceIntegrations?.[0]?.integProps?.integId;
  }, [appProperties]);
};

export const getCurrentPlanName = (planName) => {
  return getPlanType(planName);
};

export const getCheckBox = (props) => {
  const { currentCheckedState, onChange, options } = props;

  return (
    <div className="d-flex mt-2 gap-3">
      {options?.map((option) => {
        return (
          <Checkbox
            key={option.value}
            className="schedule-check-box hs-fs-16"
            value={option.value}
            onChange={(e) => {
              onChange(e);
            }}
            checked={currentCheckedState === option.value}
          >
            {option.label}
          </Checkbox>
        );
      })}
    </div>
  );
};

export const initiateOutboundCall = (toNumber, associatedObjectId, associatedObjectType, appProperties, setAppProperties) => {
  console.log("CTC initiateOutboundCall >>>>>>>>>>", toNumber, appProperties, setAppProperties);
  if (toNumber && appProperties && setAppProperties) {
    const clearExitingCallProperties = () => {
      setAppProperties((prev) => {
        return {
          ...prev,
          callerNumber: "",
          callRecordId: "",
          callRecordModule: "",
          callType: "",
        };
      });
    };
    clearExitingCallProperties();
    setAppProperties((prev) => {
      console.log("CTC clearExitingCallProperties >>>>>>", prev);
      return {
        ...prev,
        callerNumber: toNumber,
        callRecordId: associatedObjectId,
        callRecordModule: associatedObjectType,
        callType: "outbound",
      };
    });
    appProperties?.controller?.showCallNotification(appProperties?.loadedSDK, "outbound", setAppProperties);
  }
};

export const handleStatusChange = (
  status,
  onlineMode,
  leftServiceId,
  appProperties,
  voiceIntegId,
  fetchData,
  setCallProperties,
  setShowOfflineMessageWhileInit
) => {
  return new Promise((resolve, reject) => {
    console.log("onlineMode dinesh kumar poloploplo ", leftServiceId, appProperties?.userId, voiceIntegId);
    if (leftServiceId && appProperties?.userId && voiceIntegId) {
      if (status === voiceAgentStatus.ONLINE_WEB || status === voiceAgentStatus.ONLINE_PHONE) {
        if (onlineMode === voiceAgentMode.OVER_THE_PHONE) {
          status = voiceAgentStatus.ONLINE_PHONE;
        } else {
          status = voiceAgentStatus.ONLINE_WEB;
        }
      }

      console.log("status dinesh kumar poloploplo", status);
      let payload = {
        status: status,
        mode: onlineMode,
      };

      fetchData(`voice/${voiceIntegId}/agents/${appProperties.userId}/status?leftServiceId=${leftServiceId}`, "PUT", payload, appProperties)
        .then((response) => {
          const statusValueResponse = JSON.parse(response);
          const statusValue = statusValueResponse?.data?.voiceAgentStatusEntity?.voiceAgentStatus || voiceAgentStatus.OFFLINE;

          if (statusValueResponse?.data?.errorMessage) {
            // If there's an error, don't update the mode
            setCallProperties((prev) => ({
              ...prev,
              agentVoiceMode: prev.agentVoiceMode,
              agentStatusValue: prev.agentStatusValue,
            }));
            resolve(statusValueResponse);
            return;
          }

          if (statusValue === voiceAgentStatus.ON_CALL || statusValue === voiceAgentStatus.AFTER_CALL_PROCESS) {
            setCallProperties((prev) => ({
              ...prev,
              agentStatusValue: voiceAgentStatus.BUSY,
              agentVoiceMode: onlineMode,
            }));
          } else {
            setCallProperties((prev) => ({
              ...prev,
              agentStatusValue: statusValue,
              agentVoiceMode: onlineMode,
            }));
          }
          console.log("statusValue :  poloploplo >>>>>>>", statusValue);
          if (statusValue === voiceAgentStatus.ONLINE_WEB) {
            setCallProperties((prev) => ({
              ...prev,
              callStatus: "idle",
            }));
            setShowOfflineMessageWhileInit(false);
            const token = statusValueResponse?.data?.capToken;
            if (token) {
              setCallProperties((prev) => ({
                ...prev,
                twilioCapToken: token,
              }));
            }
          }
          resolve(statusValueResponse);
        })
        .catch((error) => {
          console.error("Error updating status:", error);
          reject(error);
        });
    } else {
      console.error("Missing leftServiceId or userId.");
    }
  });
};

export const defaultCallFlowConfiguration = {
  ringingType: ringingType.SIMULTANEOUS,
  ringInterval: 60,
  repeatCount: 3,
  routeType: callRouteType.DIRECT,
};